export const FETCH_LOCATION_INSIGHTS = "app/LocationInsights/FETCH";
export const FETCH_LOCATION_INSIGHTS_SUCCESS =
  "app/LocationInsights/FETCH_SUCCESS";
export const FETCH_LOCATION_INSIGHTS_FAILURE =
  "app/LocationInsights/FETCH_FAILURE";
